import Heading from "../Heading";
import { ArrowForwardIos } from "@mui/icons-material";
import { Box, Card, Grid, Button } from "@mui/material";

export default function QuickLinksSection() {
  const links = [
    "What is Travel Insurance?",
    "Reasons to Buy Travel Insurance",
    "Travel Insurance Key Facts",
    "What's Covered?",
  ];

  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Card sx={{ borderRadius: 4, p: 3 }}>
        <Box mb={3}>
          <Heading title="Quick Links" />
        </Box>

        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          {links.map((text, idx) => (
            <Grid item md={4} xs={6} key={idx} width="350px">
              <Button
                variant="outlined"
                endIcon={<ArrowForwardIos fontSize="small" />}
                sx={{
                  justifyContent: "space-between",
                  width: "100%",
                  fontFamily: '"Poppins", serif',
                }}
              >
                {text}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Card>
    </Box>
  );
}
